import { useEffect, useMemo, useState } from "react";
import {
  loadZipLookup,
  zipLookupKey,
  type ZipLookup,
  type ZipLocation,
} from "./zip-lookup";

/**
 * Resolves a US billing ZIP to city and state. Other countries return null
 * and keep collecting those fields by hand.
 */
export function useUsBillingZip(
  isUS: boolean,
  zipCode: string,
): { zipLocation: ZipLocation | null; zipUnknown: boolean } {
  const [zipLookup, setZipLookup] = useState<ZipLookup | null>(null);

  useEffect(() => {
    if (!isUS) return;
    let active = true;
    loadZipLookup()
      .then((lookup) => {
        if (active) setZipLookup(() => lookup);
      })
      .catch(() => {
        // Until the dataset loads the CTA stays disabled.
      });
    return () => {
      active = false;
    };
  }, [isUS]);

  return useMemo(() => {
    if (!isUS || !zipLookup) {
      return { zipLocation: null, zipUnknown: false };
    }
    const key = zipLookupKey(zipCode);
    const zipLocation = key ? zipLookup(key) : null;
    return {
      zipLocation,
      zipUnknown: Boolean(key && !zipLocation),
    };
  }, [zipCode, isUS, zipLookup]);
}
